import SuggestionsSearch from './suggestions-search';
import FilteringMenu from '../../sections/collection/FilteringMenu';
import initSelectNewColor from '../../sections/collection/selectNewColor';
import { setCurrentPageSearch, getCurrentPageSearch, per_page } from '../../sections/collection/filtering';

export default class OverlaySearchNosto {
  elements;
  suggestionsSearch;
  NostoRecommendationsInstance;

  constructor(NostoRecommendationsInstance) {
    this.NostoRecommendationsInstance = NostoRecommendationsInstance;

    this.elements = {
      // resetButton: document.querySelector('[data-overlay-search-reset]'),
      closeButton: document.querySelector('[data-overlay-search-close]'),
      // sortByField: document.querySelector('[data-overlay-search-sort-by]'),
      // paginationFirstButton: document.querySelector('[data-overlay-search-pagination-first]'),
      // paginationLastButton: document.querySelector('[data-overlay-search-pagination-last]'),
      // paginationNextButton: document.querySelector('[data-overlay-search-pagination-next]'),
      // paginationPreviousButton: document.querySelector('[data-overlay-search-pagination-previous]'),
    };

    this.suggestionsSearch = new SuggestionsSearch(NostoRecommendationsInstance);
    this.suggestionsSearch.initEvents();
    this.suggestionsSearch.getAutocompleteSuggestions();
    new FilteringMenu([], true);

    this.bindEvents();

    // Enable click on swatches
    initSelectNewColor();
  }

  bindEvents = () => {
    if (this.elements.closeButton !== null) {
      this.elements.closeButton.addEventListener('click', this.handleClose.bind(this));
    }

    // if (this.elements.paginationFirstButton !== null) {
    //   this.elements.paginationFirstButton.addEventListener('click', this.handlePaginationFirst.bind(this));
    // }

    // if (this.elements.paginationLastButton !== null) {
    //   this.elements.paginationLastButton.addEventListener('click', this.handlePaginationLast.bind(this));
    // }

    // if (this.elements.paginationNextButton !== null) {
    //   this.elements.paginationNextButton.addEventListener('click', this.handlePaginationNext.bind(this));
    // }

    // if (this.elements.paginationPreviousButton !== null) {
    //   this.elements.paginationPreviousButton.addEventListener('click', this.handlePaginationPrevious.bind(this));
    // }
  };

  handleClose = (e) => {
    e.preventDefault();

    if (document.querySelector('.nosto-form__clear-button')) { document.querySelector('.nosto-form__clear-button').click(); }
    document.querySelector('body').classList.remove('has-overlay-search');
    document.querySelector('.overlay-search').classList.remove('opened');
    document.querySelector('.overlay-search').classList.remove('results-visible');
    document.querySelector('[data-overlay-search-results] .grid').innerHTML = '';
    document.querySelector('[data-main-nav]').style.display = 'block';
    window.scroll();
  };

  /*
  handlePaginationFirst = async (e) => {
    const item = e.currentTarget;

    if (item.classList.contains('disabled')) {
      return;
    }

    setCurrentPageSearch(1);
    await this.fullSearch.pageSearch();

    // [ADA] Focus new element
    if (document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]').length > 0) {
      document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]')[0].focus();
    }
  };

  handlePaginationLast = async (e) => {
    const item = e.currentTarget;

    if (item.classList.contains('disabled')) {
      return;
    }

    const total_pages = Math.ceil(this.fullSearch.algolia_nbHits / per_page);
    setCurrentPageSearch(total_pages);
    await this.fullSearch.pageSearch();

    // [ADA] Focus new element
    if (document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]').length > 0) {
      document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]')[0].focus();
    }
  };

  handlePaginationNext = async (e) => {
    const item = e.currentTarget;

    if (item.classList.contains('disabled')) {
      return;
    }

    const total_pages = Math.ceil(this.fullSearch.algolia_nbHits / per_page);

    let current_page = getCurrentPageSearch();
    current_page++;
    if (current_page > total_pages) {
      current_page = total_pages;
    }
    setCurrentPageSearch(current_page);
    await this.fullSearch.pageSearch();
    
    // [ADA] Focus new element
    if (document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]').length > 0) {
      document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]')[0].focus();
    }
  };

  handlePaginationPrevious = async (e) => {
    const item = e.currentTarget;

    if (item.classList.contains('disabled')) {
      return;
    }

    let current_page = getCurrentPageSearch();
    current_page--;
    if (current_page < 0) {
      current_page = 0;
    }
    setCurrentPageSearch(current_page);

    await this.fullSearch.pageSearch();
        
    // [ADA] Focus new element
    if (document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]').length > 0) {
      document.querySelectorAll('[data-overlay-search-grid-container] [data-product-tile]')[0].focus();
    }
  };
  */
}
